import $http from "@/plugins/axios";
const AgentQuickResponseService = {
    create(botCode, title, content, type, group) {
        return $http.post(`/live-support/agent-quick-response/${botCode}`, {title, content, type, group});
    },
    findAll(botCode, isCommon=false) {
        return $http.get(`/live-support/agent-quick-response/${botCode}?isCommon=${isCommon}`)
    },
    findById(botCode, id) {
        return $http.get(`/live-support/agent-quick-response/${botCode}/${id}`)
    },
    update(botCode, id, title, content, type, group) {
        return $http.put(`/live-support/agent-quick-response/${botCode}/${id}`, {title, content, type, group})
    },
    deleteOne(botCode, id) {
        return $http.delete(`/live-support/agent-quick-response/${botCode}/${id}`);
    },
    onUseTemplate(botCode, id, senderId, channel) {
        return $http.put(`/live-support/agent-quick-response/onUseTemplate/${botCode}/${id}`, {
            sender_id: senderId,
            channel: channel
        })
    }
}

export default AgentQuickResponseService;
